module.exports = __webpack_public_path__ + "media/images/app/benefits/maintenance-8450f16baf0a72881fc0cd90025d639f.webp";